import { commonAxios } from "../utils/AxiosSettings";
export async function getPresignedUrlFromFileIDs(fileIds) {
    const res = await commonAxios.get(
        `${process.env.REACT_APP_BASE_URL_API}/api/accounts/upload/?file_ids=${fileIds}`
    );
    return res;
}
